/*
 * @description:
 * @author: Jason Wong
 * @since: 2022-07-27 16:45:23
 */
import mockjs, { mock } from "mockjs";
import { isBlank } from "../../utils/String";

const ATE_PROJECT = mockjs.mock({
  id: "@id",
  creatorId: "@id",
  creatorUserName: "@name",
  srcLang: "zh",
  tgtLang: "en",
});

const TERM_LINES = {
  lines: [
    {
      id: "001",
      src: "收音机以最大音量播放摇滚乐。",
      tgt: "The radio blasted out rock music at full volume.",
    },
    {
      id: "002",
      src: "我喜欢边熨衣服边听收音机。",
      tgt: "I like listening to the radio when I'm doing the ironing.",
    },
    {
      id: "003",
      src: "中国是一个有着悠久历史的文明古国。",
      tgt: "China is an ancient civilization with a long history",
    },
  ],
  terms: [
    {
      id: mockjs.Random.id(),
      src: "收音机",
      srcLength: 3,
      frequency: 2,
      selected: true,
      translations: [
        {
          id: mockjs.Random.id(),
          lineId: "001",
          length: 5,
          term: "radio",
          positions: [{ start: 4, end: 9 }],
        },
        {
          id: mockjs.Random.id(),
          lineId: "002",
          length: 5,
          term: "radio",
          positions: [{ start: 24, end: 29 }],
        },
      ],
    },
    {
      id: mockjs.Random.id(),
      src: "中国",
      srcLength: 2,
      frequency: 2,
      selected: false,
      translations: [
        {
          id: mockjs.Random.id(),
          lineId: "003",
          length: 5,
          term: "china",
          positions: [{ start: 0, end: 5 }],
        },
      ],
    },
  ],
};

const EXTRACT_STATE = {
  waiting: 0,
  extracting: 1,
  done: 2,
  error: 3,
};

export const SUPPORT_LANGUAGE_CODES = ["zh", "en", "de", "fr", "it", "es", "ru"];


/**
 * 单语术语提取支持语种
 * @type {string[]}
 */
export const AIGC_ATE_LANGS = {
  "中文": "zh",
  "英语": "en",
  "日语": "ja",
  "法语": "fr",
  "德语": "de",
  "俄语": "ru",
  "西班牙语": "es",
  "葡萄牙语": "pt",
  "韩语": "ko",
  "泰语": "th",
  "马来语": "ms"
}

export function checkLanguageSupportForAigcATE(lang) {
  if (!lang) return false;
  // Extract the language prefix (text before '-')
  const langPrefix = lang.split('-')[0].toLowerCase();
  return Object.values(AIGC_ATE_LANGS).indexOf(langPrefix) > -1;
}

export function checkLanguageSupportForSrc(src){
  if (!src) return false;
  const langPrefix = src.split('-')[0].toLowerCase();
  return SUPPORT_LANGUAGE_CODES.indexOf(langPrefix) >= 0;
}

export function checkLanguageSupport(src, tgt) {
  if (!src || !tgt) return false;

  return SUPPORT_LANGUAGE_CODES.indexOf(src) >= 0 && SUPPORT_LANGUAGE_CODES.indexOf(tgt) >= 0;
}

const LONGEST_TERM_COUNT = 20;
const MAX_LENGTH_OF_ONE_TERM = 250;
function checkTermTgtIsValid(termRow) {
  console.log('#-# checkTermTgtIsValid');
  if (isBlank(termRow.tgt)) return [true];

  let totalCount = 0;
  const segments = termRow.tgt.split(",");
  for (const seg of segments) {
    if (isBlank(seg)) continue;

    const segTxt = seg.trim();
    if (segTxt.length > MAX_LENGTH_OF_ONE_TERM) {
      return [false, "单个术语长度不能超过250字符。"];
    }
    totalCount++;
    if (totalCount > LONGEST_TERM_COUNT) {
      return [false, "单条术语条目个数不能超过20。"];
    }
  }

  return [true];
}

export { ATE_PROJECT, TERM_LINES, EXTRACT_STATE, checkTermTgtIsValid };
